import { Component, Input } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { InformationMessage } from 'src/app/services/notify/information.types';

@Component({
  selector: 'app-info-varsling-popup',
  templateUrl: './info-varsling-popup.component.html',
  styleUrls: ['./info-varsling-popup.component.scss']
})
export class InfoVarslingPopupComponent {
  // Brukes til å koble sammen trigger-knapp og modalen som åpnes
  @Input() popupId: string;
  @Input() message: InformationMessage;

  constructor(public modalCtrl: ModalController) {}

  ngOnInit() {
    // Assign random id to each popup after adding them to every page
    this.popupId = this.popupId + Math.random();
  }

  closeModal() {
    this.modalCtrl.dismiss();
  }

  shouldShowMessage(): boolean {
    const now = new Date();
    const from = new Date(this.message.fra);
    const to = new Date(this.message.til);

    return this.message.aktivert && now >= from && now <= to;
  }
}
